import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { appConfig } from '../../../../appConfig';
import { useAppDispatch } from '../../../common/hooks/useThunkDispatch';
import { cartThunks } from '../../../common/thunks/cartThunks';
import { ga4UserTracking } from '../../../common/tracking/ga4/user';

export const useInitialCartFetch = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(cartThunks.getCart());
    }, [dispatch]);
};

const REDIRECT_REASON_QUERY_KEY = 'redirectReason';
export const useRedirectReasonHandler = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const redirectReason = searchParams.get(REDIRECT_REASON_QUERY_KEY);
        if (!redirectReason) return;

        switch (redirectReason) {
            case 'accountRemoved': {
                ga4UserTracking.accountRemoved();
                break;
            }
            case 'loginSuccess': {
                ga4UserTracking.login(
                    appConfig.coopUserSettings.isAuthenticatedWithBankId ? 'bankid' : 'email',
                    'done',
                    'header',
                );
                break;
            }
            case 'signup': {
                ga4UserTracking.signup(
                    appConfig.coopUserSettings.isMedmeraCustomer ? 'membership' : 'account',
                    appConfig.coopUserSettings.isCompany ? 'business' : 'private',
                    appConfig.coopUserSettings.isAuthenticatedWithBankId ? 'bankid' : 'email',
                );
                break;
            }
            case 'loginAndConnectMembership': {
                ga4UserTracking.connectMembership('success', 'login');
                break;
            }

            default: {
                // eslint-disable-next-line no-console
                console.error('Unknown redirect reason: ', redirectReason);
            }
        }
    }, [searchParams]);
};
